import React, {useEffect} from 'react';
import {Navigate, useLocation} from "react-router-dom";
import {useFusionAuth} from "@fusionauth/react-sdk";
import {PATH_STRINGS} from "./routes/route-props";
import AuthenticatingUser from "./screens/authenticating-user/AuthenticatingUser";
import FullscreenSpinner from "./molecules/fullscreen-spinner/FullscreenSpinner";
import Cookies from "js-cookie";
import {USER_COOKIE} from "./constants/default-values";
import {UserCookie} from "./api/model/common";

const App = () => {
    const {isAuthenticated, isLoading, login, logout} = useFusionAuth()
    const location = useLocation()
    const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    useEffect(() => {
        const checkCookie = async () => {
            let localCookieValue = Cookies.get(USER_COOKIE)
            while (localCookieValue === undefined) {
                await sleep(100)
                localCookieValue = Cookies.get(USER_COOKIE)
            }
            if (localCookieValue !== undefined) {
                const userCookie = Cookies.get(USER_COOKIE)
                if (typeof userCookie !== 'undefined') {
                    const cookieJson: UserCookie = JSON.parse(userCookie)
                    if (
                        process.env.REACT_APP_FUSION_AUTH_CLIENT_ID !== cookieJson.applicationId &&
                        process.env.REACT_APP_INSTANCE !== 'local'
                    ) logout()
                }
            }
        }
        // needed when user logs in on production instance, closes the tab/window without logging out and then opens stage
        // instance. FusionAuth cannot verify user, and App loads indefinitely. Because of that, logout to delete cookie.
        checkCookie()
    }, []);

    useEffect(() => {
        if (!isLoading && !isAuthenticated) login()
    }, [isAuthenticated, isLoading, location.pathname]);

    if (isLoading) return <AuthenticatingUser/>
    if (isAuthenticated) return <Navigate to={PATH_STRINGS.travelDatabase}/>
    if (!isAuthenticated) login()
    return <FullscreenSpinner showLogo={true}/>
}
export default App;
